import { render, staticRenderFns } from "./DemoTradingAccount.vue?vue&type=template&id=4dd9ac43"
import script from "./DemoTradingAccount.vue?vue&type=script&lang=js"
export * from "./DemoTradingAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports